import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

import { TransientProps } from '@common/types';

export const Container = styled(motion.dialog)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
    padding: 0 1rem 1rem 0;
    position: absolute;
    right: 0;
    margin-left: auto;
    width: 72%;
    height: 100%;
    background: ${theme.colors.background[100]};
    color: ${theme.colors.foreground[100]};
    z-index: 5;
    pointer-events: all;

    box-shadow: 0px 2.8px 2.2px rgba(0, 0, 0, 0.02),
      0px 6.7px 5.3px rgba(0, 0, 0, 0.028), 0px 12.5px 10px rgba(0, 0, 0, 0.035),
      0px 22.3px 17.9px rgba(0, 0, 0, 0.042),
      0px 41.8px 33.4px rgba(0, 0, 0, 0.05), 0px 100px 80px rgba(0, 0, 0, 0.07);

    > button:first-child {
      margin-right: -0.5rem;
    }
  `}
`;

type NavigateProps = TransientProps<{
  active: boolean;
}>;

export const NavLink = styled(Link)<NavigateProps>`
  ${({ theme, $active: isActive }) => css`
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    width: 100%;

    font-size: 1rem;
    font-weight: 400;
    overflow: hidden;
    white-space: nowrap;
    color: ${isActive
      ? theme.colors.brand.primary.default
      : theme.colors.foreground[100]};
    border-left: 0.25rem solid
      ${isActive
        ? theme.colors.brand.primary.default
        : theme.colors.background[100]};

    > svg {
      margin: 0.75rem 0.25rem 0.75rem 1.75rem;
    }

    :hover {
      color: ${theme.colors.brand.primary.default};
      border-right-color: ${theme.colors.brand.primary.default};
    }
  `}
`;

export const NavButton = styled(NavLink).attrs(() => ({
  $active: false,
}))`
  ${() => css`
    background: none;
    justify-content: flex-start;
    padding: 0;
  `}
`;

export const LanguageSection = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0.75rem 0;
    border-top: 1px solid ${theme.colors.background[80]};
    border-bottom: 1px solid ${theme.colors.background[80]};
    margin: 0.5rem 0;
  `}
`;

export const LanguageTitle = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    font-size: 1rem;
    font-weight: 500;
    color: ${theme.colors.foreground[100]};
    padding-right: 0.25rem;

    > svg {
      margin: 0.5rem 0.25rem 0.5rem 1.75rem;
    }
  `}
`;

export const LanguageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-right: 1rem;
  margin-top: 0.5rem;
`;

type LanguageButtonProps = TransientProps<{
  active: boolean;
}>;

export const LanguageButton = styled.button<LanguageButtonProps>`
  ${({ theme, $active }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    width: 100%;
    padding: 0.5rem 0.75rem;
    background: ${$active ? theme.colors.background[80] : 'transparent'};
    border: none;
    border-radius: 0.375rem;
    font-size: 0.875rem;
    color: ${$active
      ? theme.colors.brand.primary.default
      : theme.colors.foreground[100]};
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background: ${theme.colors.background[80]};
    }
  `}
`;
